import { EXPORT_TO_CSV_MEASUREMENTS, REQUEST } from 'constants/actions';

export default function exportToCSVMeasurements(types, id, values) {
  return { type: EXPORT_TO_CSV_MEASUREMENTS + REQUEST, types, id, values };
}
